module.exports = __webpack_public_path__ + "static/media/luther_project.f8cc0b31.png";